module.exports = __webpack_public_path__ + "static/chara-432e21bc9baf372cc936e516d0ac546f.png";